/**
 * tabs
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_tabs.twig';
import './_tabs.css';

export const name = 'tabs';

export const defaults = {
  dummyClass: 'js-tabs-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { tabs = {} }) {
  // Find our component within the DOM
  const $tabs = $('.tabs', $context);
  // Bail if component does not exist
  if (!$tabs.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...tabs,
  };
  // An example of what could be done with this component
  $tabs.addClass(settings.dummyClass);
}

function initTabsDraggable() {
  const slider = document.querySelector('.horizontal-tabs-list-wrapper');
  if (slider) {
    let mouseDown = false;
    let startX, scrollLeft;
  
    let startDragging = function (e) {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };
    let stopDragging = function (event) {
      mouseDown = false;
    };
  
    slider.addEventListener('mousemove', (e) => {
      e.preventDefault();
      if(!mouseDown) { return; }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    });
  
    // Add the event listeners
    slider.addEventListener('mousedown', startDragging, false);
    slider.addEventListener('mouseup', stopDragging, false);
    slider.addEventListener('mouseleave', stopDragging, false);
  }
  
}

function refreshMap() {
  $('.horizontal-tab-button a').click(function() {

    // get href value
    var hrefValue = $(this).attr('href');

    // check href value
    if (hrefValue == "#edit-group-location-weather") {
      $(".leaflet-field").show();
    }
    else {
      $(".leaflet-field").hide();
    }
  });
}


$(document).ready(function() {
  $('.leaflet-field').hide();
  refreshMap();

  initTabsDraggable();
  /* remove inline styling thats causing slick rendering issue 
     read more at https://github.com/kenwheeler/slick/issues/187#issuecomment-6023519
  */ 
  $('.drupal-horizontal-tabs details').attr('style', function(i, style) {
    return style && style.replace(/display[^;]+;?/g, '');
  });

});

export default enable;

